import { render, staticRenderFns } from "./FiltroPrestadores.vue?vue&type=template&id=65c81771"
import script from "./FiltroPrestadores.vue?vue&type=script&lang=js"
export * from "./FiltroPrestadores.vue?vue&type=script&lang=js"
import style0 from "./FiltroPrestadores.vue?vue&type=style&index=0&id=65c81771&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports